"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsAsciiValidator {
    isValid(input) {
        if (input) {
            return validatorJS.isAscii(input);
        }
        return false;
    }
}
exports.IsAsciiValidator = IsAsciiValidator;
//# sourceMappingURL=IsAsciiValidator.js.map